const readMore = {
	
	ui: {},

	init: function() {
		const allReadMore = document.querySelectorAll('.js-readMore');
		allReadMore.forEach(readMore => {
			readMore.addEventListener('click', () => {
				readMore.classList.add('--hidden');

				const target = readMore.getAttribute('data-read-more');
				const activeTarget = document.querySelector(`.js-readMore-target[data-read-more="${target}"]`);
				if (activeTarget) {
					activeTarget.classList.add('--readMore');
				}
			});
		});
	},
};

module.exports = readMore;